const SupportEmail = () => {
  return (
    <a className="text-primary font-semibold" href="mailto:support@ontik.io">support@ontik.io</a>
  );
};

export default SupportEmail;